export const seatErrorRegExp = new RegExp(`^Seat \\S+ not available`);
export const SeatNotAvailable = 'Selected seat is not available';

export const pnrBlockedRegExp = /The PNR is blocked by another user \(.*\). Please try again later\./m;
export const pnrBlockedMessage =
	'The service is temporarily unavailable. It is possible that the order is open on another device/browser or being handled by an airline specialist. Please try again later.';

export const authRequiredForSecondaryOpsExp = /Auth required for secondary operations/i;
